// extracted by mini-css-extract-plugin
module.exports = {"createProjectDialog":"createProjectDialog--2Nj8c","more":"more--3Wf1q"};